module.exports = __webpack_public_path__ + "img/execute.af9ec766.svg";